import axios from "axios";
import config from "../config";

export function getByBillingId(id = "") {
  return axios.get(`${config.api_url}/customers/search/${id}`);
}
